import React, { useState } from 'react';
import { RefreshCw, Calendar as CalendarIcon, ExternalLink } from 'lucide-react';
import { calendarService } from '../../services/api';

const SyncEventButton = ({ eventId, isSynced, onSyncComplete, googleConnected, outlookConnected }) => {
  const [syncing, setSyncing] = useState(false);
  const [error, setError] = useState(null);

  const handleSync = async () => {
    try {
      setSyncing(true);
      setError(null);

      const promises = [];
      if (googleConnected) promises.push(calendarService.googleCalendar.syncEvent(eventId));
      if (outlookConnected) promises.push(calendarService.outlookCalendar.syncEvent(eventId));

      const results = await Promise.all(promises);

      if (onSyncComplete) {
        onSyncComplete(results[0]?.data);
      }

    } catch (error) {
      setError(error.response?.data?.detail || 'Sync failed');
    } finally {
      setSyncing(false);
    }
  };

  if (isSynced) {
    return (
      <div className="flex items-center space-x-1 text-green-600 text-sm">
        <CalendarIcon className="h-4 w-4" />
        <span>Synced</span>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <button
        onClick={handleSync}
        disabled={syncing}
        className="flex items-center space-x-1 px-2 py-1 text-sm bg-gray-100 text-yellow-600 rounded hover:bg-blue-200 disabled:opacity-50"
      >
        <RefreshCw className={`h-3 w-3 ${syncing ? 'animate-spin' : ''}`} />
        <span>{syncing ? 'Syncing...' : 'Sync'}</span>
        <ExternalLink className="h-3 w-3" />
      </button>
      
      {error && (
        <span className="text-xs text-red-600 mt-1">{error}</span>
      )}
    </div>
  );
};

export default SyncEventButton;
